export function getItemNumber(pageSize, currentPage, itemIndex) {
  // Calculate the global index of the item in the list
  const globalIndex = (currentPage - 1) * pageSize + itemIndex + 1;

  // Convert the global index to a two-digit string
  const itemNumberString = globalIndex.toString().padStart(2, '0');

  return itemNumberString;
  }
  